<template>
	<div
		:id="getTabpanelId(currentTabHash)"
		class="w-full mt-10"
		role="tabpanel"
		tabindex="0"
		:aria-labelledby="getTabId(currentTabHash)"
	>
		<div class="tab-content tab-space">
			<div
				:class="[
					'cms-element-product-description-reviews__description max-w-[640px]'
				]"
			>
				<div
					v-if="currentTabHash !== ProductDetailsTabs.SPECIFICATION"
					class="mt-2"
					v-html="description"
				></div>
				<div v-else class="mt-2 flex flex-col text-base">
					<div
						v-for="parametric in currentTabSpecification"
						:key="parametric.Id"
						class="flex justify-between flex-1 py-4 border-b border-gray-dark"
					>
						<span class="font-bold basis-[65%]">{{ parametric.Name }}</span>
						<span class="basis-[30%] flex justify-end">{{
							formatParametricValue(parametric.Value, t)
						}}</span>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script setup lang="ts">
import { formatParametricValue } from "~/utils/product/parametricValues";
import { getTabId, getTabpanelId } from "~/utils/product/productTabIds";
import type { VariantParametric } from "@nwt/norce-pwa/dist/runtime/types/api/product/product";

const { t } = useI18n();

interface Props {
	description: string | undefined;
	currentTabHash: string;
	currentTabSpecification: VariantParametric[] | undefined;
}

defineProps<Props>();
</script>
